import { Component, OnInit } from '@angular/core';
import { User } from '../_models/index';
import { AlertService, UserService } from '../_services/index';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-approval',
  templateUrl: './user-approval.component.html',
  styleUrls: ['./user-approval.component.css']
})
export class UserApprovalComponent implements OnInit {
	model: any = {};
    currentUser: User;
    rolelist: Array<Object>=[];
    users: User[] = [];
    loading = false;
  	uid : number;

	constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private alertService: AlertService) {
		this.route.params.subscribe( params => { this.uid=params.uid;  console.log(this.uid)} );
		this.userService.getById(this.uid)
	    .subscribe(
	        data => {
	            console.log(data)
	            this.model.username = data["username"]
	            this.model.first_name = data["first_name"]
	            this.model.last_name = data["last_name"]
	            this.model.email = data["email"]
	            this.model.organization = data["organization"]
	            this.model.role = data["role"]
	            this.model.id = data["id"]
	            this.model.team = data["team"]
	            /*this.model.password = data["password"]*/
	            this.model.is_active = 1

	        },
	        error => {
/*	            this.alertService.error(error);
	            this.loading = false;*/
	    });
	}
	ngOnInit() {
		this.rolelist = [{id:1,name:'National Team Member'},{id:2,name:'Generic User'}];
	}

    approve() {
    	this.loading = true;
        this.userService.update(this.model)
            .subscribe(
                data => {
                    console.log(this.model);
                    this.alertService.success('Successfully Updated User', true);
                    this.router.navigate(['/home']);
                },
                error => {
                    this.alertService.error(JSON.stringify(error.error));
                    this.loading = false;
                });

    }


}



// WEBPACK FOOTER //
// ./src/app/user-approval/user-approval.component.ts